import { BaseModel } from "@blue-chip/core";
import Revision from "./Revision";

export default class RevisionActivity extends BaseModel {
  static get belongsTo() {
    return [Revision];
  }
}
